<template>
  <div class="modal-card">
    <b-loading :is-full-page="false" :active.sync="loading" ></b-loading>
    <header class="modal-card-head">
      <p class="modal-card-title">Enviar proyecto </p>
    </header>
    <section class="modal-card-body" v-if="isSubmited">
      Estupendo ya has enviado tu proyecto!
    </section>
    <footer class="modal-card-foot" v-if="isSubmited">
      <button class="btn btn-bg" v-on:click="hideSubmit"> close </button>
    </footer>
    <div class="modal-card-body" v-else-if="!isSubmited">
      <div id="convocatoria-wrapper" >
        <h2 v-if="activeCalls.length >0"> Vas a enviar el proyecto a la siguiente convocatoria: </h2>
        <h2 v-else> Lo sentimos, actualmente no hay ninguna conovocatoria abierta, comprueba la web de vez en cuando para ver cuando será la siguiente </h2>

        <div v-if="activeCalls.length>1" class="call-name-multiple is-flex" >
          <b-field :type="selectedcallFormType" :message="selectedcallFormMessage">
            <b-select placeholder="convocatoria" v-model="selectedCall" >
              <option
                  v-for="option in activeCalls"
                  :value="option"
                  :key="option.id">
                  {{ option.name }}
              </option>
            </b-select>
          </b-field>
          <div v-if="selectedCall"> {{selectedCall.description}}
            <br/> <small> Convocatoria abierta hasta: </small> {{getDateString}}
          </div>
        </div>
        <div v-else-if="activeCalls.length === 1" class="call-name">
          Sólo hay una convocatoria activa:
          <h2> {{activeCalls[0].name}} </h2>
          {{activeCalls[0].description}}
        </div>
      </div>
      <div class="columns">
        <div class="column is-7">
          <!-- <h2> DATOS DEL PROYECTO </h2> -->
              <b-field  label="Título" custom-class="mandatory" :type="projectNameFormType">
                <b-input  v-model="projectName"></b-input>
              </b-field>
              <b-field label="Descripción">
                <b-input :value="description" v-model="description"></b-input>
              </b-field>
              <label class="label is-inline" style="margin-bottom: 0px;"> Clase asociada: </label>
                <span v-if="selectedClassroom"> El proyecto pertenece a la clase {{ selectedClassroom }} </span>
                <span v-else>  El proyecto no pertenece a ninguna clase </span>
              <p class="is-size-7"> <a @click="gotoProyectConfig" > Cambiar <span class="icon"> <i class="mdi mdi-pencil"></i></span></a></p>
              <!-- <div id="clase" v-if="isAuthenticated">
                <h1> Clase </h1>
                <ClassroomSelectList @input2="selectClassroom"  :currentClassroom="selectedClassroom" :user="this.$store.state.user" :alwaysDisplay="false" headerText="Añadir proyecto a la clase:"></ClassroomSelectList>
                <div style="font-size:14px">
                  * Si tu clase no aparece aquí, tienes que añadirla primero en tu <router-link :to="{ name: 'User'}" target="_blank"> configuración de usuario </router-link>
                </div>
              </div> -->

              <!-- <h2> TUS DATOS PERSONALES </h2> -->
              <!--<b-field  label="Tu nombre" custom-class="mandatory" :type="userNameFormType">
                <b-input  v-model="userNameModel" placeholder="Nombre del autor del proyecto"></b-input>
              </b-field> -->
              <!-- <label class="label" style="margin-bottom:0px;"> Nombre: </label>
              {{userName}} -->
              <article v-if="!userNameValid" class="message is-danger">
                 <div class="message-header"> <p>Error</p>  </div>
                 <div>  <router-link :to="{ name: 'usersettings' }"> Por favor edita tu nombre de usuario en tu perfil </router-link>
                </div>
              </article>
              <template v-else>
                <sketch-public-info :project="project" :projectname="projectName" :forceshow="true"> </sketch-public-info>
                <p class="user-description"> *Así se verá tu información al publicar el proyecto. Si quieres añadir tu nombre y web <router-link :to="{ name: 'usersettings' }"> Edita toda tu información personal </router-link> y después vuelve a enviarlo</p>
              </template>

  <!--            <b-field label="sketch Name">
                <b-input v-model="projectName"></b-input>
              </b-field>
              <b-field label="tags">
                <b-input v-model="tags"></b-input>
              </b-field> -->
            </div>
            <div class="column is-4 is-offset-1">
              <div id="previewer-container">
                <EditorScreenshotSaver :project = "project" />
              </div>
            </div>
          </div>
        <!--  <h1 class="is-size-3"> CONVOCATORIA </h1> -->

          <div v-if="showErrorMessages">
            <b-notification title="" :active.sync="showErrorMessages" class="" type="is-danger">
              Por favor revisa que todos los campos obligatorios están rellenos
            </b-notification>
          </div>
        </div>
        <footer class="modal-card-foot" v-if="!isSubmited">
          <div class="field" >
               <b-checkbox v-model="checkbox_conditions" :type="checkbox_type">
                  <span :class="checkbox_type"> Al enviar un proyecto a una convocatoria no podrás editarlo más. Aceptas que el código fuente puede ser público y el proyecto expuesto en esta web y en la fachada de Medialab-prado. <br/> La organización se reserva el derecho de retirar contenido no apropiado. </span>
               </b-checkbox>
           </div>
          <button class="btn btn-bg" v-on:click="hideSubmit"> Cancelar </button>
          <button v-if="activeCalls.length >0" class="btn btn-bg-colored" v-on:click="sendAndClose" > Enviar </button>
        </footer>
      </div>
</template>

<script>
import ClassroomSelectList from '../UI/ClassroomSelectList'
import Previewer from '../Previewer/Previewer'
import SketchPublicInfo from '../UI/SketchPublicInfo'
import EditorScreenshotSaver from './EditorScreenshotSaver'

export default {
  name: 'EditorSendProject',
  props: {
    project: Object
  },
  components: {
    ClassroomSelectList,
    SketchPublicInfo,
    EditorScreenshotSaver,
    Previewer
  },
  computed: {
    userName () {
      return this.$store.state.user.userInfo.name
    },
    projectNameFormType () {
      if (this.projectName.length < 2) return 'is-danger'
      else return 'is-success'
    },
    userNameValid () {
      return (this.userNameModel.length > 1)
    },
    userNameFormType () {
      if (this.userNameModel.length < 2) return 'is-danger'
      else return 'is-success'
    },
    selectedcallFormType () {
      if (this.triedToSend === false) return ''
      if (!this.selectedCall) return 'is-danger'
      else return 'is-success'
    },
    selectedcallFormMessage () {
      if (this.triedToSend === false) return ''
      if (!this.selectedCall) return 'Elige convocatoria'
      else return ''
    },
    institution () {
      return this.$store.state.user.userInfo.institution
    },
    activeCalls () {
      return this.$store.state.activeCalls
    },
    isAuthenticated () {
      return this.$store.getters['auth/isAuthenticated']
    },
    remoteCover () {
      return this.project.cover
    },
    displayCover () {
      if (this.remoteCover !== null || this.coverbase64 !== null) return true
      else return false
    },
    getDateString () {
      if (this.selectedCall) {
        var d = new Date(this.selectedCall.date_to)
        return d.toLocaleDateString('es-ES')
      } else {
        return ''
      }
    },
    checkbox_type () {
      if (!this.triedToSend) return ''
      else if (this.checkbox_conditions) return 'is-success'
      else return 'is-danger'
    }
    /* projectName: {
      get () {
        return this.$store.state.project.name
      },
      set (value) {
        this.$store.commit('setProjectName', value)
      }
    },
    projectDescription: {
      get () {
        return this.$store.state.project.description
      },
      set (value) {
        this.$store.commit('setProjectDescription', value)
      }
    } */

  },
  data () {
    return {
      projectName: this.project.name,
      userNameModel: this.$store.state.user.userInfo.name,
      description: this.project.description,
      call: ['actual', 'ninguna'],
      tags: '',
      isSubmited: false,
      loading: true,
      selectedCall: null,
      selectedClassroom: this.project.classroom,
      showErrorMessages: false,
      agreeSendWithoutCover: false,
      checkbox_conditions: false,
      triedToSend: false
    }
  },
  methods: {
    selectClassroom: function (classinfo) {
      this.selectedClassroom = classinfo.id
      this.isClassroomStudent = classinfo.isClassroomStudent
    },
    hideSubmit: function () {
      console.log('hideSetings')
      this.$store.commit('setEditorConfigProperty', {'isShowingSubmit': false})
    },
    gotoProyectConfig: function () {
      this.$store.commit('setEditorConfigProperty', {'isShowingSubmit': false})
      this.$store.commit('setEditorConfigProperty', {'isShowingSettings': true})
    },
    validateForms: function () {
      this.triedToSend = true
      if (this.selectedCall && this.checkbox_conditions && this.userNameModel.length > 2 && this.projectName.length > 2) {
        this.showErrorMessages = false
        if (this.displayCover === true || this.agreeSendWithoutCover === true) {
          return true
        } else {
          this.$dialog.confirm({
            cancelText: 'Volver y añadir captura',
            confirmText: 'Enviar sin captura',
            message: '¿Estás seguro de que deseas enviar el proyecto sin una imagen identificativa?',
            onConfirm: () => {
              this.agreeSendWithoutCover = true
              this.sendAndClose()
            }
          })
          return false
        }
      } else {
        this.showErrorMessages = true
        return false
      }
    },
    sendAndClose: function () {
      if (this.validateForms() === false) return

      this.$store.commit('setProjectProperty', {'call': this.selectedCall.id})
      this.$store.commit('setProjectFinished')
      this.$store.commit('setProjectPublic')
      this.$store.dispatch('saveProject')
        .then(response => {
          this.isSubmited = true
          console.log('saved project')
        }).catch((error) => {
          console.log('saveProject', 'FAIL', error)
        })
    }
  },
  created () {
    this.$store.dispatch('fetchActiveCallList')
      .then(() => {
        console.log('this.activeCalls.length')
        console.log(this.activeCalls.length)
        if (this.activeCalls.length === 1) {
          this.selectedCall = this.$store.state.activeCalls[0]
        }
      })
    this.$store.dispatch('user/fetchUserInfo')
      .then(() => {
        this.loading = false
      })
  }
}

</script>

<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

h2 {
  font-size:20px;
}

.modal-card{
  width: 70vw;
  max-width:768px;
  margin:auto;
}
.modal-card-body{
  padding-top: 0px;
}
.modal-card-foot .field {
  span.is-danger{
    color:red
  }
  span.is-success{
    color:@accentColor
  }
}
#previewer-container{
  max-width:192px;
}
#capture{
  margin-left:0px;
  margin-right:0px;
  max-width:192px;
  .text-in-btn{
    font-size:16px;
  }
}
#display-cover{
  margin-top: 2em;
  img {
    border: 1px solid #efefef
  }
}
#convocatoria-wrapper{
  background-color: @accentColorSecondary;
  margin-left:-20px;
  margin-right:-20px;
  padding:20px;
  margin-bottom:20px;
  text-align: center;
  color: @secondaryTextColor;
  .call-name{
    color:white;
    p{
      font-size:20px;
    }
  }
  .call-name-multiple{
    justify-content: space-around;
    align-items: center;
    flex-flow: column;
  }
}

.user-description {
  margin-top: 25px;
  color: #7a6d71;
}

</style>



// WEBPACK FOOTER //
// src/components/Editor/EditorSendProject.vue